const styles = (theme) => ({
  mainContent: {
    marginLeft: 180,
    minHeight: "100vh",
    backgroundColor: "#F6F8FA",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  pageHeader: {
    background: "linear-gradient(135deg, #1a2235 0%, #2A3142 60%, #3a4460 100%)",
    padding: theme.spacing(5, 6),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3, 2),
    },
  },
  pageTitle: {
    color: "#FFFFFF",
    fontWeight: 800,
    fontSize: "2rem",
    letterSpacing: "-0.5px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
    },
  },
  pageSubtitle: {
    color: "rgba(255,255,255,0.65)",
    fontSize: "1rem",
    marginTop: theme.spacing(0.5),
  },
  pageBody: {
    padding: theme.spacing(4, 6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 2),
    },
  },

  // ── Filtres thèmes ──────────────────────────────────────────────
  filtersRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  filterChip: {
    borderRadius: "20px",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.85rem",
    minHeight: "32px",
    padding: "4px 16px",
  },
  filterChipActive: {
    backgroundColor: "#2A3142",
    color: "#FFFFFF",
    border: "1px solid #2A3142",
    "&:hover": { backgroundColor: "#1a2030" },
  },
  filterChipInactive: {
    backgroundColor: "#FFFFFF",
    color: "#555",
    border: "1px solid #E0E0E0",
    "&:hover": { backgroundColor: "#F5F5F5" },
  },

  // ── Section titre ──────────────────────────────────────────────
  sectionTitle: {
    fontWeight: 700,
    fontSize: "1.15rem",
    color: "#2A3142",
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  sectionDivider: {
    marginBottom: theme.spacing(4),
  },

  // ── Carte hero (on_request) ────────────────────────────────────
  heroCard: {
    borderRadius: "16px",
    overflow: "hidden",
    marginBottom: theme.spacing(3),
    boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "row",
    height: "340px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "auto",
    },
  },
  heroImageWrapper: {
    position: "relative",
    flex: "0 0 42%",
    height: "100%",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flex: "none",
      height: "200px",
    },
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  heroImagePlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#C8D0DC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroImageOverlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to right, rgba(26,34,53,0.15) 0%, rgba(26,34,53,0) 100%)",
    [theme.breakpoints.down("sm")]: {
      background: "linear-gradient(to bottom, rgba(26,34,53,0) 50%, rgba(26,34,53,0.5) 100%)",
    },
  },
  heroBadgeWrapper: {
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  heroBadgeOnRequest: {
    backgroundColor: "#FF7043",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "0.72rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  heroThemeBadge: {
    backgroundColor: "rgba(40,80,200,0.85)",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "0.72rem",
    fontWeight: 600,
    backdropFilter: "blur(4px)",
  },
  heroContent: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5),
    },
  },
  heroTitle: {
    fontWeight: 800,
    fontSize: "1.6rem",
    color: "#1a2235",
    lineHeight: 1.2,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.25rem",
    },
  },
  heroDescription: {
    color: "#4B5563",
    fontSize: "0.95rem",
    lineHeight: 1.6,
    marginBottom: theme.spacing(2.5),
    display: "-webkit-box",
    "-webkit-line-clamp": 4,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
  },
  heroStats: {
    display: "flex",
    gap: theme.spacing(3),
    flexWrap: "wrap",
    marginBottom: theme.spacing(3),
  },
  heroStatItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#6B7280",
    fontSize: "0.9rem",
    fontWeight: 500,
  },
  heroStatValue: {
    fontWeight: 700,
    color: "#2A3142",
    fontSize: "1.1rem",
  },
  heroActions: {
    display: "flex",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  heroRequestButton: {
    borderRadius: "24px",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.9rem",
    padding: "10px 24px",
    backgroundColor: "#FF7043",
    color: "#FFFFFF",
    "&:hover": { backgroundColor: "#e5622f" },
  },
  heroLinkButton: {
    borderRadius: "24px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.9rem",
    padding: "10px 24px",
    backgroundColor: "transparent",
    color: "#2A3142",
    border: "1.5px solid #2A3142",
    "&:hover": { backgroundColor: "rgba(42,49,66,0.06)" },
  },

  // ── Grille modèles standard ────────────────────────────────────
  toursGrid: {
    marginTop: theme.spacing(1),
  },
  tourCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    transition: "box-shadow 0.2s ease, transform 0.15s ease",
    height: "100%",
    "&:hover": {
      boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
      transform: "translateY(-2px)",
    },
  },
  tourCardImageWrapper: {
    position: "relative",
    width: "100%",
    height: "150px",
    overflow: "hidden",
  },
  tourCardImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    display: "block",
  },
  tourCardImagePlaceholder: {
    width: "100%",
    height: "150px",
    backgroundColor: "#C8D0DC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  durationBadge: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: "rgba(30,30,30,0.75)",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "2px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "0.75rem",
    fontWeight: 600,
    backdropFilter: "blur(4px)",
  },
  infoButton: {
    position: "absolute",
    top: theme.spacing(0.75),
    left: theme.spacing(0.75),
    backgroundColor: "rgba(255,255,255,0.88)",
    padding: "4px",
    width: "28px",
    height: "28px",
    backdropFilter: "blur(4px)",
    "&:hover": { backgroundColor: "#FFFFFF" },
  },
  themeBadge: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: "rgba(40,80,200,0.78)",
    color: "#FFFFFF",
    borderRadius: "6px",
    padding: "2px 8px",
    fontSize: "0.7rem",
    fontWeight: 600,
    maxWidth: "70%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    backdropFilter: "blur(4px)",
  },
  tourCardContent: {
    padding: theme.spacing(1.5, 1.5, 0.5),
    flexGrow: 1,
  },
  tourCardTitle: {
    fontWeight: 700,
    fontSize: "0.9rem",
    color: "#2A3142",
    lineHeight: 1.3,
  },
  tourCardStats: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5, 1),
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    color: "#6B7280",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  tourCardActions: {
    padding: theme.spacing(0, 1.5, 1.5),
  },
  copyButton: {
    textTransform: "none",
    borderRadius: "20px",
    width: "100%",
    backgroundColor: "#5E77FF",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "0.85rem",
    "&:hover": { backgroundColor: "#4a63e8" },
    "&:disabled": { backgroundColor: "#A0AABF", color: "#FFFFFF" },
  },

  // ── Popover description ────────────────────────────────────────
  descriptionPopover: {
    padding: theme.spacing(2),
    maxWidth: "280px",
  },

  // ── États ──────────────────────────────────────────────────────
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(8),
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(6),
    color: "#888",
  },
  messagesContainer: {
    marginBottom: theme.spacing(2),
  },
});

export default styles;
